import http from 'hub-http/clients/apiClient';
import { SEATS_INVENTORY } from '../constants/EarlyRequesterNames';
import getEarlyRequesterResult from './getEarlyRequesterResult';
const ENDPOINT = 'monetization/v3/seats/inventory';
export const getSeatsInventory = () => {
  const earlyRequest = getEarlyRequesterResult(SEATS_INVENTORY);
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => http.get(ENDPOINT)) : null;
  return earlyRequestWithRetry || http.get(ENDPOINT);
};